import { DatePicker, Button, Space } from "antd";
const { RangePicker } = DatePicker;

const DateRangeFilter = ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
  return (
    <div style={{ padding: 8 }}>
      <RangePicker
        value={selectedKeys.length ? selectedKeys : null}
        onChange={(dates) => {
          if (dates && dates.length === 2) {
            //  keep dayjs ONLY
            setSelectedKeys(dates);
          } else {
            setSelectedKeys([]);
          }
        }}
      />

      <Space style={{ marginTop: 8 }}>
        <Button size="small" type="primary" onClick={() => confirm()}>
          Apply
        </Button>
        <Button
          size="small"
          onClick={() => {
            clearFilters();
            confirm();
          }}
        >
          Reset
        </Button>
      </Space>
    </div>
  );
};

export default DateRangeFilter;
